import { useMemo, useState } from "react";
import { Tag } from "../DownloadForm";
import { GroupedTags } from "./TagSelectionDisplay";

export const useTagFiltering = (
  tags: Tag[],
  excludedStatusNames: readonly string[] = ["招待前", "停止中"],
) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredTags = useMemo(() => {
    return tags
      .filter(
        (tag) =>
          !(tag.type === "status" && excludedStatusNames.includes(tag.name)),
      )
      .filter((tag) =>
        searchTerm
          ? tag.name.toLowerCase().includes(searchTerm.toLowerCase())
          : true,
      );
  }, [tags, searchTerm, excludedStatusNames]);

  const groupedTags = useMemo((): GroupedTags => {
    const groups: GroupedTags = {
      status: [],
      job: [],
      tag_ids: [],
    };

    filteredTags.forEach((tag) => {
      if (tag.type === "status") {
        groups.status.push(tag);
      } else if (tag.type === "job") {
        groups.job.push(tag);
      } else if (tag.type === "tag_ids") {
        groups.tag_ids.push(tag);
      }
    });

    return groups;
  }, [filteredTags]);

  return {
    searchTerm,
    setSearchTerm,
    filteredTags,
    groupedTags,
  };
};
